import usePopperState from "Hooks/usePopperState";
import { createContext, ReactNode, useContext, useMemo } from "react";

interface ICampaignAnalysisContextType {
  anchorConversionEl: any;
  onConversionRefChange: (event: any) => void;
  isConversionOpen: boolean;

  anchorMetricEl: any;
  onMetricRefChange: (event: any) => void;
  isMetricOpen: boolean;

  anchorModelEl: any;
  onModelRefChange: (event: any) => void;
  isModelOpen: boolean;
}

const CampaignAnalysisContext = createContext<ICampaignAnalysisContextType>({
  anchorConversionEl: null,
  onConversionRefChange: () => { },
  isConversionOpen: false,

  anchorMetricEl: null,
  onMetricRefChange: () => { },
  isMetricOpen: false,

  anchorModelEl: null,
  onModelRefChange: () => { },
  isModelOpen: false,
});

export const useCampaignAnalysis = () => useContext(CampaignAnalysisContext);

function CampaignAnalysisProvider({ children }: { children: ReactNode }) {
  const [anchorConversionEl, onConversionRefChange, isConversionOpen] =
    usePopperState();
  const [anchorMetricEl, onMetricRefChange, isMetricOpen] = usePopperState();
  const [anchorModelEl, onModelRefChange, isModelOpen] = usePopperState();

  const contextValue = useMemo(
    () => ({
      anchorConversionEl,
      onConversionRefChange,
      isConversionOpen,
      anchorMetricEl,
      onMetricRefChange,
      isMetricOpen,
      anchorModelEl,
      onModelRefChange,
      isModelOpen,
    }),
    [
      anchorConversionEl,
      onConversionRefChange,
      isConversionOpen,
      anchorMetricEl,
      onMetricRefChange,
      isMetricOpen,
      anchorModelEl,
      onModelRefChange,
      isModelOpen,
    ]
  );

  return (
    <CampaignAnalysisContext.Provider value={contextValue}>
      {children}
    </CampaignAnalysisContext.Provider>
  );
}

export default CampaignAnalysisProvider;
